import { useEffect, useState } from 'react';
import { Table, Card, ScrollArea, Space, Title, Text } from '@mantine/core';

const NotesCard = (props) => {
    const [rows, setRows] = useState();

    useEffect(() => {
        if (props.matches) {
            let array = Object.entries(props.matches);
            let row = [];

            for (var i = 0; i < array.length; i++) {
                const match = array[i][1] || {};
                row.push(Object.create({
                    "match": array[i][0],

                    "autoNotes": match.autoNotes?.replace(/>/g, ' ').replace(/</g, ','),
                    "driveNotes": match.driveNotes?.replace(/>/g, ' ').replace(/</g, ','),
                    "intakeNotes": match.intakeNotes?.replace(/>/g, ' ').replace(/</g, ','),
                    "defenseNotes": match.defenseNotes?.replace(/>/g, ' ').replace(/</g, ','),
                    "cycleNotes": match.cycleNotes?.replace(/>/g, ' ').replace(/</g, ','),
                    "climbNotes": match.climbNotes?.replace(/>/g, ' ').replace(/</g, ','),
                    "shootNotes": match.shootNotes?.replace(/>/g, ' ').replace(/</g, ','),
                    "scouter": match.scouter,
                    "key": i
                }));
            }
            setRows(row);
        }
    }, [props]);

    return (
        <Card padding="xl">
            <Title order={2}>Notes</Title>
            <Space h="xl" />
            <ScrollArea h={400}>
                <Table highlightOnHover verticalSpacing="md" fontSize="md">
                    <thead>
                        <tr>
                            <th style={{ fontSize: '20px', padding: '12px' }}>Qual</th>
                            <th style={{ fontSize: '20px', padding: '12px' }}>Auto</th>
                            <th style={{ fontSize: '20px', padding: '12px' }}>Drive</th>
                            <th style={{ fontSize: '20px', padding: '12px' }}>Intake</th>
                            <th style={{ fontSize: '20px', padding: '12px' }}>Defense</th>
                            <th style={{ fontSize: '20px', padding: '12px' }}>Cycle</th>
                            <th style={{ fontSize: '20px', padding: '12px' }}>Climb</th>
                            <th style={{ fontSize: '20px', padding: '12px' }}>Shoot</th>
                            <th style={{ fontSize: '20px', padding: '12px' }}>Scouter</th>
                        </tr>
                    </thead>
                    <tbody>{
                        rows && rows.map((row) => (
                            <tr key={row.key}>
                                <td style={{ padding: '12px' }}><Text size="lg">{row.match}</Text></td>
                                <td style={{ padding: '12px' }}><Text size="lg">{row.autoNotes}</Text></td>
                                <td style={{ padding: '12px' }}><Text size="lg">{row.driveNotes}</Text></td>
                                <td style={{ padding: '12px' }}><Text size="lg">{row.intakeNotes}</Text></td>
                                <td style={{ padding: '12px' }}><Text size="lg">{row.defenseNotes}</Text></td>
                                <td style={{ padding: '12px' }}><Text size="lg">{row.cycleNotes}</Text></td>
                                <td style={{ padding: '12px' }}><Text size="lg">{row.climbNotes}</Text></td>
                                <td style={{ padding: '12px' }}><Text size="lg">{row.shootNotes}</Text></td>
                                <td style={{ padding: '12px' }}><Text size="lg">{row.scouter}</Text></td>
                            </tr>
                        ))
                    }
                    </tbody>
                </Table>
            </ScrollArea>
        </Card>
    )
}

export default NotesCard;